import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type { ProgramNodeProps } from '../implementations/Node';
import type { ParagraphExerciseProps, ParagraphPhaseProps } from '../implementations/Paragraph';

interface ExerciseValues {
  currentProgram: string;
  currentPhase: string;
  currentExercise: string;
}

/**
 * Get the program, phase and exercise of a given webform id.
 *
 * @param {ProgramNodeProps[]} programs - All program nodes to check for.
 * @param {string} id - Id of the webform.
 * @returns {ExerciseValues} Object with currentProgram, currentPhase and currentExercise.
*/
// eslint-disable-next-line import/prefer-default-export
export function getWebformExerciseDetails(
  programs: ProgramNodeProps[],
  id: string,
): ExerciseValues {
  let currentProgram = '';
  let currentPhase = '';
  let currentExercise = '';

  programs.forEach((program) => {
    const phases = program.field_paragraphs as unknown as ReferenceField<ParagraphPhaseProps>[];

    phases.forEach((phase, phaseIndex) => {
      const phaseEntity = phase.entity;
      // eslint-disable-next-line max-len
      const exercises = phaseEntity.field_exercise as unknown as ReferenceField<ParagraphExerciseProps>[];

      exercises.forEach((exercise, exerciseIndex) => {
        const exerciseEntity = exercise.entity;

        if (exerciseEntity.field_webform[0].target_id === id) {
          currentProgram = program.title[0].value;
          currentPhase = `phase_${phaseIndex + 1}`;
          currentExercise = `exercise_${phaseIndex + 1}_${exerciseIndex + 1}`;
        }
      });
    });
  });

  return {
    currentProgram,
    currentPhase,
    currentExercise,
  };
}
